import setAppPaneUnderlayVisibility from 'owa-app-pane-underlay/lib/actions/setAppPaneUnderlayVisibility';
import type { NavBarLinkData } from '@1js/suiteux-shell-react';

export const flexPaneVisiblityChanged = (isVisible: boolean) => {
    setAppPaneUnderlayVisibility('suiteFlexPane', isVisible, true /* isShrinkable */);
};

export const createHelpLink = (
    id: string,
    helpText: string,
    url?: string,
    action?: () => void
): NavBarLinkData => {
    return {
        Id: id,
        Text: helpText,
        Url: url,
        TargetWindow: '_blank',
        Action: action,
    } as NavBarLinkData;
};
